import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { Layout } from "./components/Layout";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Brands from "./pages/Brands";
import BrandDetail from "./pages/BrandDetail";
import Branches from "./pages/Branches";
import BranchDetail from "./pages/BranchDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import Quotation from "./pages/Quotation";
import Design from "./pages/Design";
import HowWeWork from "./pages/HowWeWork";
import Sectors from "./pages/Sectors";
import ThankYou from "./pages/ThankYou";
import BusinessAccount from "./pages/BusinessAccount";
import Consultation from "./pages/Consultation";
import RestaurantOpening from "./pages/RestaurantOpening";
import UrgentRequest from "./pages/UrgentRequest";
import BusinessHubPage from "./pages/BusinessHubPage";
import Fabrication from "./pages/Fabrication";
import SectorDetail from "./pages/SectorDetail";
import Maintenance from "./pages/Maintenance";
import ClientPortal from "./pages/ClientPortal";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/:slug" element={<BrandDetail />} />
            <Route path="/branches" element={<Branches />} />
            <Route path="/branches/:slug" element={<BranchDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quotation />} />
            <Route path="/design" element={<Design />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/sectors/:slug" element={<SectorDetail />} />
            <Route path="/business-hub" element={<BusinessHubPage />} />
            <Route path="/fabrication" element={<Fabrication />} />
            <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/client-portal" element={<ClientPortal />} />
            <Route path="/business-account" element={<BusinessAccount />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/restaurant-opening" element={<RestaurantOpening />} />
            <Route path="/urgent-request" element={<UrgentRequest />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
